import React from 'react'
import { Skeleton, styled, useMediaQuery, useTheme } from '@mui/material';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import {
    Card, ContentSlider, ImageCard, Parent, Section, TitleCard, Image, HeadingText,
    SubHeadingText, TitleDisc, SectionRate, ContentTab, ContentTabList, SwiperContainer, PaginationContainer
} from './StyledSliderRow'
import { TabContext, TabPanel } from '@mui/lab';
import HooksHeader from '../../../../hooks/hooksHeader'
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import StarIcon from '@mui/icons-material/Star';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ArrowLeft } from '../../../../images';
import { Box } from '@mui/system';
const SliderRowExplore = () => {
    const swiperRef = React.useRef(null);
    const { value, handleChange,
        dataCourse, LoadingCourse,
        dataCourse2, LoadingCourse2,
        dataCourse3, LoadingCourse3,
        fetchCourse } = HooksHeader();
    const [SlideNum, setSlideNum] = React.useState(4)
    const CustomSwiper = styled(Swiper)({
        marginBottom: '0px',
        '.swiper-pagination-bullet-active': {
            width: '20px',
            borderRadius: '30%'
        },
        '.swiper-pagination': {
            display: 'flex',
            justifyContent: 'flex-start',
            // position: 'relative',
            alignItems: 'center',
        },
    });

    const theme = useTheme()
    const med = useMediaQuery(theme.breakpoints.up('xs'))
    const lg = useMediaQuery(theme.breakpoints.up('md'))
    const xs = useMediaQuery(theme.breakpoints.down('xs'))
    const sm = useMediaQuery(theme.breakpoints.down('sm'))
    React.useEffect(() => {
        if (med)
            setSlideNum(2)
        if (xs)
            setSlideNum(2)
        if (lg)
            setSlideNum(4)
    }, [med])
    return (
        <Section>
            <HeadingText>
                المناهج التعليمية
            </HeadingText>
            <TabContext value={value}>
                <ContentTabList onChange={handleChange} >
                    <ContentTab style={{ margin: ' 12px 0 ' }} value="تاسع" label='تاسع' />
                    <ContentTab value="بكلوريا علمي" label='  بكالوريا علمي' />
                    {dataCourse3 && dataCourse3?.data?.data?.courses.length > 0 ? <ContentTab value="بكلوريا أدبي" label='بكالوريا أدبي' /> : null}
                </ContentTabList>
                <TabPanel style={{ padding: '0', height: '430px' }} value="تاسع">
                    <CustomSwiper
                        style={{ width: xs ? '120%' : '100%', position: 'relative' }}
                        ref={swiperRef}
                        slidesPerView={SlideNum}
                        modules={[Pagination]}
                        pagination={true} >
                        {!LoadingCourse && dataCourse ? dataCourse?.data?.data?.courses.map((card, index) => (
                            <>
                                <SwiperSlide key={card.id} >
                                    <Fade big cascade key={card.id}>
                                        <Link style={{ textDecoration: 'none' }} to={`about-course/${card.id}`}>
                                            <Card key={card.id}>
                                                <ImageCard>                                                            <Image
                                                    style={{
                                                        minWidth: 144,
                                                        height: 144,
                                                    }}
                                                    alt={""}
                                                    src={`${process.env.REACT_APP_BASE_URL}/${card.image_path}`}
                                                />
                                                </ImageCard>
                                                <TitleCard>
                                                    {
                                                        card.name
                                                    }
                                                </TitleCard>
                                                <TitleDisc>
                                                    {card.brief.slice(0, 120)}
                                                </TitleDisc>
                                                {/* <SectionRate>
                                                <StarIcon sx={{ color: '#F2C94C' }} />
                                                <span style={{ fontWeight: '600', fontSize: '16px', color: '#333333' }} >
                                                    {card.rate}
                                                </span>
                                                <TitleDisc style={{ minHeight: 'inherit' }}>
                                                    ({card.rate}  تقييم)
                                                </TitleDisc>
                                            </SectionRate> */}
                                            </Card>
                                        </Link>
                                    </Fade>
                                </SwiperSlide>
                                {index === dataCourse?.data?.data?.courses.length - 1 && <SwiperSlide style={{ width: '100px' }} key={'card.id'} />}
                            </>
                        )) : (
                            <>
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                            </>
                        )}
                        <Link style={{
                            fontSize: '14px', position: 'absolute', bottom: '0%', width: 'fit-content',
                            left: sm ? '60px' : '30px', fontWeight: '00', marginBottom: '5px', color: '#0056D2', textDecoration: 'none', zIndex: '12222'
                        }} to={`/all-course/تاسع`} className="swiper-pagination">
                            رؤية المزيد <img src={ArrowLeft} alt='leftArrow' />
                        </Link>                    </CustomSwiper>
                    {/* <button
                        style={{ width: '200px', background: 'red' }}
                        className="navigate-next"
                        onClick={() => swiperRef.current.swiper.slideNext()}
                    >
                        "next"
                    </button> */}

                </TabPanel>
                <TabPanel style={{ padding: '0', height: '430px' }} value="بكلوريا علمي">
                    <CustomSwiper
                        // direction='rtl'
                        style={{ width: xs ? '120%' : '100%' }}
                        ref={swiperRef}
                        slidesPerView={SlideNum}
                        modules={[Pagination]}
                        pagination={true}
                    >
                        {
                            !LoadingCourse2 && dataCourse2 ? dataCourse2.data.data.courses.map((card, index) => <>
                                <SwiperSlide key={card.id} >
                                    <Fade big cascade key={card.id}>
                                        <Link style={{ textDecoration: 'none' }} to={`about-course/${card.id}`}>
                                            <Card key={card.id}>
                                                <ImageCard>                                                            <Image
                                                    style={{
                                                        minWidth: 144,
                                                        height: 144,
                                                    }}
                                                    alt={""}
                                                    src={`${process.env.REACT_APP_BASE_URL}/${card.image_path}`}
                                                />
                                                </ImageCard>
                                                <TitleCard>
                                                    {
                                                        card.name
                                                    }
                                                </TitleCard>
                                                <TitleDisc>
                                                    {card.brief.slice(0, 120)}
                                                </TitleDisc>
                                                {/* <SectionRate>
                                                    <StarIcon sx={{ color: '#F2C94C' }} />
                                                    <span style={{ fontWeight: '600', fontSize: '16px', color: '#333333' }} >
                                                        {card.rate}
                                                    </span>
                                                    <TitleDisc style={{ minHeight: 'inherit' }}>
                                                        ({card.rate}  تقييم)
                                                    </TitleDisc>
                                                </SectionRate> */}
                                            </Card>
                                        </Link>
                                    </Fade>
                                </SwiperSlide>
                                {index === dataCourse2?.data?.data?.courses.length - 1 && <SwiperSlide style={{ width: '100px' }} key={'card.id'} />}
                            </>
                            )
                                : <>
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                </>
                        }
                        <Link style={{
                            fontSize: '14px', position: 'absolute', bottom: '0%', width: 'fit-content',
                            left: sm ? '60px' : '30px', marginBottom: '5px', color: '#0056D2', textDecoration: 'none', zIndex: '12222'
                        }} to={`/all-course/بكلوريا علمي`} >
                            رؤية المزيد <img src={ArrowLeft} alt='leftArrow' />
                        </Link>
                    </CustomSwiper>
                </TabPanel>
                {dataCourse3 && dataCourse3.data.data.courses.length > 0 ? <TabPanel style={{ padding: '0', height: '430px' }} value="بكلوريا أدبي">
                    <CustomSwiper
                        // direction='rtl'
                        style={{ width: '100%' }}
                        ref={swiperRef}
                        slidesPerView={SlideNum}
                        modules={[Pagination]}
                        pagination={true}
                    >
                        {
                            !LoadingCourse3 && dataCourse3 ? dataCourse3.data.data.courses.map((card) => <>
                                <SwiperSlide key={card.id} >
                                    <Fade big cascade key={card.id}>
                                        <Link style={{ textDecoration: 'none' }} to={`about-course/${card.id}`}>
                                            <Card key={card.id}>
                                                <ImageCard>                                                            <Image
                                                    style={{
                                                        minWidth: 144,
                                                        height: 144,
                                                    }}
                                                    alt={""}
                                                    src={`${process.env.REACT_APP_BASE_URL}/${card.image_path}`}
                                                />
                                                </ImageCard>
                                                <TitleCard>
                                                    {
                                                        card.name
                                                    }
                                                </TitleCard>
                                                <TitleDisc>
                                                    {card.brief.slice(0, 120)}
                                                </TitleDisc>
                                                {/* <SectionRate>
                                                    <StarIcon sx={{ color: '#F2C94C' }} />
                                                    <span style={{ fontWeight: '600', fontSize: '16px', color: '#333333' }} >
                                                        {card.rate}
                                                    </span>
                                                    <TitleDisc style={{ minHeight: 'inherit' }}>
                                                        ({card.rate}  تقييم)
                                                    </TitleDisc>
                                                </SectionRate> */}
                                            </Card>
                                        </Link>
                                    </Fade>
                                </SwiperSlide>
                            </>
                            )
                                : <>
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                    <Skeleton style={{ minWidth: '144px', height: "174px" }} />
                                </>
                        }
                        <Link style={{
                            fontSize: '14px', position: 'absolute', bottom: '0%', width: 'fit-content',
                            left: '30px', marginBottom: '5px', color: '#0056D2', textDecoration: 'none', zIndex: '12222'
                        }} to={`/all-course/بكلوريا أدبي`} className="swiper-pagination">
                            رؤية المزيد <img src={ArrowLeft} alt='leftArrow' />
                        </Link>
                    </CustomSwiper>
                </TabPanel> : null}
            </TabContext>

        </Section >
    )
}

export default SliderRowExplore